import { render, staticRenderFns } from "./index.vue?vue&type=template&id=78ea10c4"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=78ea10c4&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=78ea10c4&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78ea10c4')) {
      api.createRecord('78ea10c4', component.options)
    } else {
      api.reload('78ea10c4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=78ea10c4", function () {
      api.rerender('78ea10c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportManage/games/index.vue"
export default component.exports